import type { ReactNode } from "react";

interface BadgeProps {
  tone?: "neutral" | "signal" | "success";
  children: ReactNode;
}

const toneClasses: Record<NonNullable<BadgeProps["tone"]>, string> = {
  neutral: "bg-paper text-ink-soft border-line",
  signal: "bg-signal-50 text-signal-600 border-signal-300",
  success: "bg-success-50 text-success-500 border-success-500/30",
};

export function Badge({ tone = "neutral", children }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${toneClasses[tone]}`}
    >
      {children}
    </span>
  );
}
